module.exports = __webpack_public_path__ + "static/tafttpt-00112c5f20b2bd532133791e893aeb13.jpg";